import { useSnapshot } from 'valtio'
import { type ReactElement, useEffect } from 'react'
import format from 'date-fns/format'
import { customerProxy } from '../../../../../shared/proxies/customerProxy'
import { CondensedAmountCell } from '../../../transactions/index/TransactionsTable/AmountCell/AmountCell'
import { buildAppTransactionPath } from '../../../../../pages/app/transactions/[id]'
import TransactionTypeLabel from '../../../../../shared/components/ui/TransactionTypeLabel'
import { executeTransactionRetrieveForCustomerDetail } from '../../../../../shared/apiUtils/executeTransactionRetrieve'

export function CustomerTransactionSection (): ReactElement {
  const { customer, customerTransactions } = useSnapshot(customerProxy)
  useEffect(() => {
    void executeTransactionRetrieveForCustomerDetail(customer?.id)
  }, [customer?.id])

  return (
    <div>
      <div className="overflow-hidden bg-white shadow sm:rounded-md">
        <ul role="list" className="divide-y divide-gray-200">
          {customerTransactions?.map((transaction) => {
            const path = buildAppTransactionPath(transaction.id)
            return (
              <li key={transaction.id}>
                <a href={path} className="block hover:bg-gray-50">
                  <div className="flex justify-between items-center px-4 py-4 sm:px-6">
                    <div className="w-1/5">
                      {format(new Date(transaction.transactedAt), 'MMM d, y')}
                    </div>
                    <div className="w-1/5">
                      # {transaction.invoiceNumber}
                    </div>

                    <div className="w-1/6">
                      <TransactionTypeLabel type={transaction.ppSslTransactionType} />
                    </div>
                    <div className="w-1/5 text-right">
                      {transaction.status}
                    </div>
                    <div className="w-1/5 text-right">
                      <CondensedAmountCell transaction={transaction} />
                    </div>
                  </div>
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
